export default __webpack_public_path__ + "static/media/Maheshwar_Fort.4c2f44df.jpg";